import { CheckoutPaymentMethod, CheckoutAdminPaymentMethod, Product, Customer, Address, VoucherOrNone, OrderPrice } from "@raskrask-dk/raskrask-utils";
import type {BookingflowStateMachine} from "../../bookingflowstatemachine";
import {State} from "../state";
import {checkActions, CheckoutActions, checkoutActions, CheckoutStateDependencies, ProductCheckout} from "./checkoutState.types";

const CHECKOUT_STATE = "CHECKOUT";
export default class CheckoutState extends State<CheckoutActions, typeof CHECKOUT_STATE> {
  public readonly type = CHECKOUT_STATE;
  private _paymentMethod: CheckoutPaymentMethod | CheckoutAdminPaymentMethod | undefined;
  private _priceToPay?: OrderPrice;
  private _product: Product;
  private _customer: Customer;
  private _address: Address;
  private _promoCode: string | undefined;
  private _voucher: VoucherOrNone | undefined;

  /**
   *
   * @param bookingflowStateMachine
   */
  constructor(bookingflowStateMachine: BookingflowStateMachine, dependencies: CheckoutStateDependencies) {
    super(bookingflowStateMachine);
    {
      const {product, customer, address, promoCode, voucher} = dependencies as ProductCheckout;
      this._product = product;
      this._customer = customer;
      this._address = address;
      this._promoCode = promoCode;
      this._voucher = voucher;
    }
  }

  doAction(action: CheckoutActions): CheckoutState {
    switch (action.type) {
      case "CHOOSE_PAYMENT_METHOD":
        this._paymentMethod = action.data;
        return this;
      case "SET_PRICE":
        this._priceToPay = action.data;
        return this;
      default:
        throw new Error("These are not the droids you are looking for");
    }
  }
  public getActions = (): checkActions[] => checkoutActions.filter((action) => new action(this).isDoable());

  /**
   *
   * @param action - The action that is given
   * On the checkoutState there are no values dependent on
   */
  public unset = (): void => {
    // you see nothing
  };

  public getData = (): {
    paymentMethod: CheckoutPaymentMethod | CheckoutAdminPaymentMethod | undefined;
    priceToPay: OrderPrice | undefined;
    product: Product;
    customer: Customer;
    address: Address;
    promoCode: string | undefined;
    voucher: VoucherOrNone | undefined;
  } => {
    return {
      paymentMethod: this.paymentMethod,
      priceToPay: this.priceToPay,
      product: this._product,
      customer: this._customer,
      address: this._address,
      promoCode: this._promoCode,
      voucher: this._voucher,
    };
  };

  public get paymentMethod(): CheckoutPaymentMethod | CheckoutAdminPaymentMethod | undefined {
    return this._paymentMethod;
  }

  public get priceToPay(): OrderPrice | undefined {
    return this._priceToPay;
  }
}
